export const FOLDER_NAME = 'PlatinumNights';
export const IMAGE_PATH = 'VenueImages';
export const FILE_NAME = 'PlatinumNightsData.json';
export const FILE_NAME_REFRESH = 'PlatinumNightsDataRefresh.json';
export const FILE_NAME_REFRESH_V2 = 'PlatinumNightsDataRefreshV2.json';
export const VENUES_FILE_NAME = 'PlatinumNightsVenues.json';
export const COMING_SOON_STATUS = 'coming soon';
export const COMING_SOON_FALLBACK_MESSAGE = 'Reservations for this Platinum Night will be available soon';
export const NOTIFY_STATUS = 'notify';
export const BOOK_NOW_STATUS = 'book';
export const PARTY_SIZE = 2;
export const ALL_UPCOMING_MONTH = -1;
export const NAA_SECTION = 'naa';
export const MGM_SECTION = 'mgm';
export const ALL_CITIES_DATA = {
  name: 'All Cities', url_slug: '', code: 'all_cities',
};

export const ALL_CITIES_WITH_DATA_REFRESH = {
  name: 'All Cities', url_slug: '', code: 'all_cities', data: true,
};
export const ALL_CITIES_DATA_REFRESH = {
  name: 'All Cities', url_slug: '', code: 'all_cities', data: false,
};

export const UPCOMING_EVENTS = 'All Upcoming';
export const UPCOMING_EVENTS_REFRESH = 'All Months';
export const VENUE_STATUS = 'All Venues';
export const VENUE_OPTIONS = [
  {
    key: '',
    value: '',
    orderId: 0,
    label: VENUE_STATUS,
  },
  {
    key: '1',
    value: BOOK_NOW_STATUS,
    orderId: 1,
    label: 'Available to Book',
  },
  {
    key: '2',
    value: COMING_SOON_STATUS,
    orderId: 2,
    label: 'Coming soon',
  },
];
export const DESKTOP_IMAGE_SIZE = '800';
export const MOBILE_IMAGE_SIZE = '400';
export const DINNER_SERVICE_TYPE_ID = 2;
export const DATE_FORMAT = 'YYYY-MM-DD';
export const REQUIRED_KEY_AMOUNT = 8;
